import { render, staticRenderFns } from "./VehicleDetailsForm.vue?vue&type=template&id=2d9ac1e4&"
import script from "./VehicleDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./VehicleDetailsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports